import { Fragment } from "react";
import { BannerGroupsInlineStyles, BannerGroup } from ".";
import { useBanner } from "../../contexts";

var BannerGroups = function BannerGroups() {
  var banner = useBanner();
  var groups = banner.groups,
      groupSpacing = banner.group.groupSpacing;
  var useGroups = groups.filter(function (_ref) {
    var items = _ref.items;
    return items.length;
  });
  return h("div", BannerGroupsInlineStyles.groups(banner), useGroups.map(function (group, index) {
    return h(Fragment, {
      key: group.id
    }, h(BannerGroup, {
      key: group.id,
      group: group
    }), index !== useGroups.length - 1 && h("div", {
      style: {
        height: +groupSpacing
      }
    }));
  }));
};

export { BannerGroups };